export const readEmpty = async (skip,query) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listKontrakEmpty?skip=${skip}&query=${query}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}